import { MUEmailGrey, MUWebsite, MUWhatsappGrey } from '../../../assets/hostedassets';
import { sourceMap } from './MagicUploadConstants';

export type DropdownOption = { value: string; label: string };

/** Returns undefined for null, empty, or literal "undefined" strings. */
export const validOrgId = (v?: string | null): string | undefined => (v && v !== 'undefined' ? v : undefined);

/**
 * Resolves the correct assesseeOrgId based on context.
 * In company context (isCompany or isBorrowerReq), URL is the source of truth
 * because Redux holds the partner's own org ID, not the target company's.
 */
export const resolveAssesseeOrgId = ({
    isCompany,
    isBorrowerReq,
    orgIdFromQuery,
    orgIdFromRoute,
    orgIdFromRedux,
}: {
    isCompany: boolean;
    isBorrowerReq: boolean;
    orgIdFromQuery: string | null;
    orgIdFromRoute: string | undefined;
    orgIdFromRedux: string | undefined;
}): string | undefined => {
    return isCompany || isBorrowerReq
        ? validOrgId(orgIdFromQuery) ?? validOrgId(orgIdFromRoute) ?? validOrgId(orgIdFromRedux)
        : validOrgId(orgIdFromRedux) ?? validOrgId(orgIdFromRoute);
};

export type SourceType = 'whats_app' | 'gmail' | 'app';

export const getSourceIcon = (source: SourceType) => {
    switch (source) {
        case 'whats_app':
            return <img src={MUWhatsappGrey} alt={'Whatsapp'} />;
        case 'gmail':
            return <img style={{ height: '22px' }} src={MUEmailGrey} alt={'Email'} />;
        case 'app':
            return <img src={MUWebsite} alt={'Website'} />;
        default:
            return '-';
    }
};

/**
 * Maps a backend source key to its display label, falling back to the raw
 * source when it isn't in sourceMap. Prevents an undefined label from reaching
 * the filter (sourceMap only covers a fixed set of known sources).
 */
export const resolveSourceLabel = (source: string): string => (sourceMap as Record<string, string>)[source] ?? source;

/**
 * Case-insensitive filter of dropdown options by search text. Guards against a
 * null/undefined label — backend-derived labels (org name, mapped source, user
 * name) can be missing, and an unguarded .toLowerCase() crashes the render.
 */
export const filterOptionsBySearch = (options: DropdownOption[], searchText: string): DropdownOption[] => {
    const query = (searchText ?? '').toLowerCase();
    return options.filter((option) => (option.label ?? '').toLowerCase().includes(query));
};
